import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-3 cursor-pointer">
            <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-xl flex items-center justify-center">
              <i className="ri-plant-line text-white text-xl"></i>
            </div>
            <span className="text-xl font-bold text-gray-900">财税知识森林</span>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <a href="/" className="text-sm font-medium text-gray-900 hover:text-emerald-600 transition-colors cursor-pointer whitespace-nowrap">
              首页
            </a>
            <a href="/knowledge" className="text-sm font-medium text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer whitespace-nowrap">
              知识板块
            </a>
            <a href="/articles" className="text-sm font-medium text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer whitespace-nowrap">
              文章资讯
            </a>
            <a href="/cases" className="text-sm font-medium text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer whitespace-nowrap">
              实务案例
            </a>
            <a href="/about" className="text-sm font-medium text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer whitespace-nowrap">
              关于我们
            </a>
          </div>

          <div className="flex items-center gap-4">
            <button className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
              <i className="ri-search-line text-xl text-gray-700"></i>
            </button>
            <a 
              href="http://xd-demo.faciotaxai.com/#/home" 
              target="_blank" 
              rel="noopener noreferrer"
              className="px-5 py-2.5 bg-gradient-to-r from-emerald-500 to-teal-500 text-white text-sm font-medium rounded-lg hover:from-emerald-600 hover:to-teal-600 transition-all whitespace-nowrap cursor-pointer"
            >
              开始探索
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}